import { render, staticRenderFns } from "./LegalInformation.vue?vue&type=template&id=24020b42&scoped=true"
import script from "./LegalInformation.vue?vue&type=script&lang=ts"
export * from "./LegalInformation.vue?vue&type=script&lang=ts"
import style0 from "./LegalInformation.vue?vue&type=style&index=0&id=24020b42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24020b42",
  null
  
)

export default component.exports